import "./TagButton.css";
import { Link } from "react-router-dom";

export default function TagButton({ tag }) {
    return (
        <Link className="tagButton" to={`/tags/${tag.slug.current}`}>
            {tag.title}
        </Link>
    );
}
